import { render, staticRenderFns } from "./PointsSummary.vue?vue&type=template&id=3fcdc065&"
import script from "./PointsSummary.vue?vue&type=script&lang=js&"
export * from "./PointsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports